import { notification } from 'antd'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import { FC, useCallback, useContext, useRef } from 'react'
import Machine from '../../../../../../components/form-items/machine/machine'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'
import { machineHasStampRoller } from '../../../../../../helpers/machine-has-stamp-roller'
import { isDurstMachine } from '../../../../../../helpers/is-durst-machine'
import { useGetMachinesQuery } from '../../../../../../store/api/machines-api'
import CalculationPosition from '../../../../../../types/api/calculation-position'
import { CalculationPageCtx } from '../../../../calculations-page'

interface MachineBrandsWrapperProps {
    record?: CalculationPosition
}

const MachineBrandsWrapper: FC<MachineBrandsWrapperProps> = ({ record }) => {
    const ctx = useContext(EditableCellCtx)
    const form = useFormInstance()
    const { onUpdateCalculationPositionProperty } = useContext(CalculationPageCtx)
    const initialMachineRef = useRef(record?.machine?.documentId)

    const { data } = useGetMachinesQuery({
        filters: { machine_type: { name: { $eq: 'platen' } } },
        populate: { rollers: true },
        sort: ['name:asc'],
    })

    const disabledMachine = (machine: Parameters<typeof machineHasStampRoller>[0]) =>
        !machineHasStampRoller(machine, record)

    const handleBlur = useCallback(() => {
        const newMachineId = form.getFieldValue(['machine', 'set']) as string | undefined
        const initialMachineId = initialMachineRef.current
        const machineChanged = newMachineId !== initialMachineId

        if (machineChanged && record) {
            const oldWasDurst = isDurstMachine(record.machine)
            const newMachine = data?.data?.find(m => m.documentId === newMachineId)
            const newIsDurst = isDurstMachine(newMachine)

            if (oldWasDurst && !newIsDurst && record.numberOfVariantsForDigit) {
                notification.warning({
                    message: 'Кол-во видов Durst сброшено',
                    description: 'Изменён станок — поле доступно только для Durst.',
                })

                void onUpdateCalculationPositionProperty(record, {
                    list: [
                        [['machine', 'set'], newMachineId],
                        ['numberOfVariantsForDigit', null],
                    ],
                })
                ctx.onCancel()
                return
            }
        }

        ctx.onBlur()
    }, [ctx, data?.data, form, onUpdateCalculationPositionProperty, record])

    return (
        <Machine
            name={['machine', 'set']}
            filters={{ machine_type: { name: { $eq: 'platen' } } }}
            unique
            noStyle
            autoFocus
            onBlur={handleBlur}
            disabledMachine={disabledMachine}
            populate={{
                rollers: true,
            }}
        />
    )
}

export default MachineBrandsWrapper
